import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import TrendingUp from "@material-ui/icons/TrendingUp";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Info from "components/Typography/Info.jsx";
import Success from "components/Typography/Success.jsx";
import Danger from "components/Typography/Danger.jsx";

import adquisition from "assets/img/Kinos/Developers/adquisition.jpeg"
import development from "assets/img/Kinos/Developers/development.jpeg";
import marketing from "assets/img/Kinos/Developers/marketing.jpeg";
import completion from "assets/img/Kinos/Developers/completion.jpg";
import construction from "assets/img/Kinos/Developers/construction.jpeg";
import sales from "assets/img/Kinos/Developers/sales.jpg";

import sectionInterestedStyle from "assets/jss/material-kit-pro-react/views/blogPostsSections/sectionInterestedStyle.jsx";

function SectionInterested({ ...props }) {
  const { classes } = props;
  return (
    <div className={classes.section}>
      <h3 className={classes.title + " " + classes.textCenter}>
        DEVELOPMENT LIFECYCLE
      </h3>
      <br />
      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader image plain>

                <img src={adquisition} alt="..." />

              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + adquisition + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>

              <h4 className={classes.cardTitle}>

                  ADQUISITION

              </h4>
              <p className={classes.description}>
                Our intimate market knowledge and sophisticated investment analysis will inform your acquisition, driving you towards a successful result
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>

                <img src={development} alt="..." />

              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + development + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>

              <h4 className={classes.cardTitle}>

                  DEVELOPMENT

              </h4>
              <p className={classes.description}>
                From supporting the development application process to influencing compelling design, we advance your development into a highly marketable product.
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>

                <img src={marketing} alt="..." />

              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + marketing + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>

              <h4 className={classes.cardTitle}>

                  MARKETING

              </h4>
              <p className={classes.description}>
                With a comprehensive understanding of buyers and the market, we design, orchestrate, and manage a marketing program tailored to your unique development.
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader image plain>

                <img src={sales} alt="..." />

              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + sales + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <h4 className={classes.cardTitle}>
                  SALES & LEASE-UP
              </h4>
              <p className={classes.description}>
                Through extensive training and management programs, our world-class, multi-tiered sales approach has been honed to generate sales beyond expectation.
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>
                <img src={construction} alt="..." />
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + construction + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <h4 className={classes.cardTitle}>
                  CONSTRUCTION
              </h4>
              <p className={classes.description}>
                As your vision unfolds into reality, we pro-actively manage sales and continue to work tirelessly through flawless collaboration with vendors and communication with homebuyers.
              </p>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <Card plain blog>
            <CardHeader plain image>
                <img src={completion} alt="..." />
              <div
                className={classes.coloredShadow}
                style={{
                  backgroundImage: "url(" + completion + ")",
                  opacity: "1"
                }}
              />
            </CardHeader>
            <CardBody plain>
              <h4 className={classes.cardTitle}>
                  COMPLETION
              </h4>
              <p className={classes.description}>
                A smooth transaction strengthens the relationship between developer and buyer throughout the completion process, generating a positive experience and future brand equity.
              </p>
            </CardBody>
          </Card>
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(sectionInterestedStyle)(SectionInterested);
